import { Meteor } from 'meteor/meteor';
import { ensureIosDevice } from '/imports/api/users';
import { IosDevice } from '/imports/types';

const w = window as any;
let _isIos = false;

if (Meteor.isClient) {
  w.ensureIosDevice = async (device: IosDevice) => {
    _isIos = true;
    try {
      await ensureIosDevice.call(device);
    }
    catch (error) {
      console.log(error);
    }
  };
}

export const isIos = () => _isIos;